import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminLayoutService } from '../../admin-layout.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

@Component({
  selector: 'app-create-modal',
  templateUrl: './create-modal.component.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CreateModalComponent implements OnInit {

  userForm: FormGroup;
  submitted = false;
  getUserType: any = [];
  selectedUserForm:any;

  constructor(
    public dialogRef: MatDialogRef<CreateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private fb: FormBuilder,
    private adminLayoutService: AdminLayoutService
  ) {

    this.getUserType = passedData?.getUserType || []
    this.selectedUserForm = passedData?.rowData || ""

    const hasEmployeeKey = !!this.selectedUserForm?.employee_key;

    // default to today for new user
    const startDate = hasEmployeeKey ? (this.selectedUserForm?.start_date || new Date()) : new Date();  

    // --- NEW LOGIC: end_date default ---
    let endDate: any;

    if (hasEmployeeKey) {
      // editing mode → use existing end_date
      endDate = this.selectedUserForm?.end_date || new Date();
    } else {
      // new user → default end = start + 7 days
      const s = new Date(startDate);
      const e = new Date(s);
      e.setDate(s.getDate() + 6);
      endDate = e;
    }

    this.userForm = this.fb.group({
      usr_email_id: [
        {
          value: hasEmployeeKey ? (this.selectedUserForm?.usr_email_id || '') : '',
          disabled: hasEmployeeKey
        },
        [Validators.required, Validators.email]
      ],

      usr_fst_nm: [
        hasEmployeeKey ? (this.selectedUserForm?.usr_fst_nm || '') : '',
        Validators.required
      ],

      usr_lst_nm: [
        hasEmployeeKey ? (this.selectedUserForm?.usr_lst_nm || '') : '',
        Validators.required
      ],

      gender: [
        hasEmployeeKey ? (this.selectedUserForm?.gender || '') : '',
        Validators.required
      ],

      start_date: [
        {
          value: startDate,
          disabled: this.selectedUserForm?.start_date ? hasEmployeeKey : false
        },
        Validators.required
      ],

      end_date: [
        endDate,
        Validators.required
      ],

      user_type_id: [{ value: 1003, disabled: true }, Validators.required]
    }, { validators: this.dateRangeValidator });

    // Auto-set end_date = start_date + 7 days
    this.userForm.get('start_date')?.valueChanges.subscribe(start => {
      if (!start) return;

      // Do not override if editing existing employee
      if (hasEmployeeKey) return;

      const startDate = new Date(start);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // +7 days

      this.userForm.get('end_date')?.setValue(endDate, { emitEvent: false });
    });

  }

  dateRangeValidator(form: FormGroup) {
    const start = form.get('start_date')?.value;
    const end = form.get('end_date')?.value;

    if (start && end && end < start) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.submitted = true;

    if (this.userForm.invalid) {
      return;
    }

    let value = this.userForm.value;
    let obj = {
      usr_display_nm: value.usr_fst_nm + ' ' + value.usr_lst_nm,
      user_id: value.usr_email_id,
      password: 'xXyYzZ',
      employee_key: this.selectedUserForm ? this.selectedUserForm.employee_key : null,
      start_date: moment(value.start_date).format("MM/DD/YYYY"),
      end_date: moment(value.end_date).format("MM/DD/YYYY"),
      user_type_id: 1003
    }

    let finalObj = Object.assign({}, value, obj)
    console.log("Form Values:", finalObj);

    this.UpdateUser(finalObj);
  }

  UpdateUser(finalObj:any) {
    this.adminLayoutService.updateUserList(finalObj).subscribe((res:any) => {
      if(res?.Result=="Success") {
        this.dialogRef.close('submit')
        if(finalObj?.employee_key) {
          this.adminLayoutService.customSnackBars('User Updated Successfully', 'success', 'green')
        } else {
          this.adminLayoutService.customSnackBars('User Created Successfully', 'success', 'green')
        }
      } else {
        if(res?.Result) {
          this.adminLayoutService.customSnackBars(res?.Result, 'warning', 'yellow')
        }
      }
    }, err => {
      let error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
      this.adminLayoutService.customSnackBars(error_name, 'warning', 'yellow')
    })
  }
}
